import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useCurrentLanguage, useSwitchCurrentLanguage } from '../../state/language';
import { detectBrowserLanguage } from './utils/detectBrowserLanguage';
/**
 * Renders a IntlProvider wrapper around its children. Tries to determine the user
 * language based on the browser settings
 */
export const LanguageProvider = (props) => {
    var _a;
    const { children, defaultLocale, messages, customFormats } = props;
    const browserLanguage = detectBrowserLanguage(defaultLocale, Object.keys(messages));
    const language = (_a = useCurrentLanguage()) !== null && _a !== void 0 ? _a : browserLanguage;
    const languageSpecificMessages = messages[language];
    const switchLanguage = useSwitchCurrentLanguage();
    useLayoutEffect(() => {
        switchLanguage(browserLanguage);
    }, [browserLanguage, switchLanguage]);
    return (_jsx(IntlProvider, Object.assign({ locale: language, defaultLocale: defaultLocale, messages: languageSpecificMessages, formats: customFormats }, { children: children }), void 0));
};
//# sourceMappingURL=LanguageProvider.js.map